import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const listBootcamps = () => api.get("/bootcamps").then((r) => r.data);
export const listModules = () => api.get("/modules").then((r) => r.data);
export const reserveBootcamp = (payload) => api.post("/bootcamps/reserve", payload).then((r) => r.data);
export const reserveModule = (payload) => api.post("/modules/reserve", payload).then((r) => r.data);
export const logScore = (payload) => api.post("/simulator/score", payload).then((r) => r.data);

export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);
export const createSession = (sessionId) =>
  api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data);

export const adminListOrders = () => api.get("/admin/orders").then((r) => r.data);
export const adminCreateBootcamp = (payload) => api.post("/admin/bootcamps", payload).then((r) => r.data);
export const adminUpdateBootcamp = (id, payload) => api.patch(`/admin/bootcamps/${id}`, payload).then((r) => r.data);
export const adminDeleteBootcamp = (id) => api.delete(`/admin/bootcamps/${id}`).then((r) => r.data);
export const adminCreateModule = (payload) => api.post("/admin/modules", payload).then((r) => r.data);
export const adminDeleteModule = (id) => api.delete(`/admin/modules/${id}`).then((r) => r.data);

export const seedDemo = () => api.post("/seed").then((r) => r.data);

export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
